import Repository from "./repository"

export default {
    /**
     * 作業可能時間数を処理
     * @param {string} iComsumptions 消費コマ数
     * @returns response
     */
    get(iComsumptions = 1) {
        return Repository.get('/api/m201-workable-schedule/get', {
            params: {
                consumption_number: iComsumptions
            }
        })
    }
}